<div class="footerSection px-2 py-3 border-top">
  <div class="d-flex align-items-center justify-content-center">
    <p class="m-0 me-2">Powered By</p>
    <a href="https://bigdot.ai/" target="_blank"
      ><img
        src="https://dkzxkcjlbnjui.cloudfront.net/uploads/media/logo/bigdot-logo.png"
        width="70px"
        class="img-fluid me-2 bigdotFooterLogo"
    /></a>
  </div>
</div>
